import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import SecurityService from '../../../services/SecurityService';
import { translate, isNullOrEmpty } from '../../../utils/util';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import * as actionsPhysicalConfirmation from '../../../actions/physicalConfirmationAction';
import { Button, Card, Breadcrumbs, SelectResource } from '../../../components/UI/ComponentsUI';

const Parameters = (props) => {
    const [model, setModel] = useState({
        resource: props.user.resource || ''
    });

    useEffect(() => {
        props.resetPhisicalConfirmation();

        if (props.user.resource !== undefined) {
            model.resource = props.user.resource;
        }
        setModel({ ...model })
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const handleFormKeyDown = (e) => {
        if (e.key === 'Enter') {
            submit();
        }
    }

    const submit = () => {
        if (validateInputsRequired("formParamsCf")) {
            props.setResource(model.resource);
            props.setFilter({ truckKanban: true })

            props.history.replace({
                pathname: '/receipt/V2/receiptStorages',
                state: { truckKanban: true },
                ...props
            });
        }
    }

    const leave = () => {
        return props.history.replace({
            pathname: `./home`,
        });
    }

    return (
        <div>
            <Breadcrumbs onClick={leave} id="receiptParameters" title={{ icon: "mdi mdi-clipboard-check-outline", label: translate('menu.configuration', 'configuration') }}
                subtitles={[{ icon: "mdi mdi-clipboard-check", label: translate('physical-confirmation:xd-conference') }]} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <Card>
                        <div>
                            <form className="col s12" onKeyDown={handleFormKeyDown}>
                                <div id="formParamsCf" className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field col s12">
                                        <SelectResource
                                            id="resource"
                                            required
                                            name="resource"
                                            value={model.resource}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="row" style={{ paddingTop: '10px' }}>
                            <div className="col s6">
                                <Button full="true" onClick={() => leave()} text={translate('cancel', 'general')} secundary="true" />
                            </div>
                            <div className="col s6">
                                <Button full="true" onClick={() => submit()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        resources: state.logisticsResourceReducer.list,
        resource: state.configReducer.resource
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetPhisicalConfirmation: () => {
            dispatch(actionsPhysicalConfirmation.clearPhysicalConfirmation());
        },
        setResource: (resource) => {
            dispatch(SecurityService.setResource(resource));
        },
        setPrinter: (printer) => {
            dispatch(SecurityService.setPrinter(printer));
        },
        setFilter: (filter) => {
            dispatch(actionsPhysicalConfirmation.setFilter(filter));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Parameters));
